var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var P4Rules_1;
import { MGPOptional, MGPValidation, Utils } from '@everyboard/lib';
import { NumberConfig } from '../../config/NumberConfig';
import { RulesConfigDescription } from '../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../config/RulesConfigDescriptionLocalizable';
import { GameNode } from '../../jscaip/AI/GameNode';
import { GameStatus } from '../../jscaip/GameStatus';
import { NInARowHelper } from '../../jscaip/NInARowHelper';
import { PlayerOrNone } from '../../jscaip/Player';
import { ConfigurableRules } from '../../jscaip/Rules';
import { TableUtils } from '../../jscaip/TableUtils';
import { Debug } from '../../utils/Debug';
import { MGPValidators } from '../../utils/MGPValidator';
import { P4Failure } from './P4Failure';
import { P4State } from './P4State';
export class P4Node extends GameNode {
}
let P4Rules = class P4Rules extends ConfigurableRules {
    static { P4Rules_1 = this; }
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Four in a Row`,
        config: {
            width: new NumberConfig(7, RulesConfigDescriptionLocalizable.WIDTH, MGPValidators.range(1, 99)),
            height: new NumberConfig(6, RulesConfigDescriptionLocalizable.HEIGHT, MGPValidators.range(1, 99)),
        },
    });
    static get() {
        if (P4Rules_1.singleton.isAbsent()) {
            P4Rules_1.singleton = MGPOptional.of(new P4Rules_1());
        }
        return P4Rules_1.singleton.get();
    }
    P4_HELPER;
    constructor() {
        super();
        this.P4_HELPER = new NInARowHelper(Utils.identity, 4);
    }
    getRulesConfigDescription() {
        return P4Rules_1.RULES_CONFIG_DESCRIPTION;
    }
    getInitialState(config) {
        const board = TableUtils.create(config.width, config.height, PlayerOrNone.NONE);
        return new P4State(board, 0);
    }
    applyLegalMove(move, state, _config, _info) {
        const x = move.x;
        const board = state.getCopiedBoard();
        const y = P4Rules_1.get().getLowestUnoccupiedSpace(board, x);
        const turn = state.turn;
        board[y][x] = state.getCurrentPlayer();
        const resultingState = new P4State(board, turn + 1);
        return resultingState;
    }
    isLegal(move, state) {
        if (state.getPieceAtXY(move.x, 0).isPlayer()) {
            return MGPValidation.failure(P4Failure.COLUMN_IS_FULL());
        }
        return MGPValidation.SUCCESS;
    }
    getGameStatus(node) {
        const state = node.gameState;
        const victoriousCoord = this.P4_HELPER.getVictoriousCoord(state);
        if (victoriousCoord.length > 0) {
            return GameStatus.getVictory(state.getCurrentOpponent());
        }
        const width = state.getWidth();
        const height = state.getHeight();
        return state.turn === (width * height) ? GameStatus.DRAW : GameStatus.ONGOING;
    }
    getVictoriousCoords(state) {
        return this.P4_HELPER.getVictoriousCoord(state);
    }
    getLowestUnoccupiedSpace(board, x) {
        let y = 0;
        const height = board.length;
        while (y < height && board[y][x].isNone()) {
            y++;
        }
        return y - 1;
    }
};
P4Rules = P4Rules_1 = __decorate([
    Debug.log
], P4Rules);
export { P4Rules };
